

import React from 'react';
import BrandedButton, { brandedButtonTypes } from '../../../utilities/inputComponents/BrandedButton'


function DialAmount({setDialAmount}) {
    return (
        <div className="warningWrapper" style={{zIndex:'10'}}>
            <div className="warningBody" style={{height:'35%'}}>
                <div className="warningHeader">
                    Dials Per Lead
                </div>
                <div className="warningContent">
                    How many dials per lead do you want to make?
                </div>
                <div className="warningButtonHolder" style={{margin: '0px 0px'}}>
                    <div className="warningButtonWrapper">
                        {/* <div className="standardButton" key={'dial1'} onClick={()=>setDialAmount(1)}>1 Dial</div>
                        <div className="standardButton" key={'dial2'} onClick={()=>setDialAmount(2)}>2 Dials</div> */}
                        <div key={'dial1'} style={{maxWidth: '400px', margin: '10px auto 0px'}}>
                            <BrandedButton
                                buttonType={brandedButtonTypes.PRIMARY}
                                buttonLabel='1 Dial'
                                clickHandler={_ => setDialAmount(1)}
                            />
                        </div>
                        <div key={'dial2'} style={{maxWidth: '400px', margin: '10px auto 0px'}}>
                            <BrandedButton
                                buttonType={brandedButtonTypes.PRIMARY}
                                buttonLabel='2 Dial'
                                clickHandler={_ => setDialAmount(2)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DialAmount;